import { useEffect } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { fetchProductSubscription } from 'actions/LuxPlusActions'

function useFetchSubscriptionItemData() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchProductSubscription())
  }, [dispatch])
}

export default useFetchSubscriptionItemData
